import { render, staticRenderFns } from "./FeaturedCards.vue?vue&type=template&id=2a6a024a&"
import script from "./FeaturedCards.vue?vue&type=script&lang=js&"
export * from "./FeaturedCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports